module.exports = "/img/ic_logo.10ece02f.webp";